import * as React from 'react'
import { Icon } from '/react4xp/components/primitives/Icon'

export interface EducationCardProps {
  title: string
  category?: string
  location?: string
  duration?: string
  credits?: string
  startDate?: string
  educationForm?: string
  url: string
  headingLevel?: 'h2' | 'h3'
  className?: string
}

export const EducationCard = ({
  title,
  category,
  location,
  duration,
  credits,
  startDate,
  educationForm,
  url,
  headingLevel = 'h3',
  className = '',
}: EducationCardProps) => {
  const Heading = headingLevel

  return (
    <article
      className={`group relative flex flex-col gap-6 rounded-xl bg-blue-300 pt-6 ${className}`}
    >
      <div className="flex flex-col gap-6 px-8">
        {category && (
          <span className="self-start rounded bg-white px-4 py-1 text-sm text-black">
            {category}
          </span>
        )}
        <div className="flex flex-col gap-1">
          <Heading
            className="text-2xl font-medium leading-snug text-black group-hover:underline hyphens-auto wrap-break-word"
            lang="nb"
          >
            <a
              className="after:absolute after:inset-0 after:z-10 after:content-['']"
              href={url}
            >
              {title}
            </a>
          </Heading>
          {location && (
            <span className="flex items-center gap-3 text-sm text-black">
              <Icon name="location_on" size={20} className="shrink-0" />
              {location}
            </span>
          )}
        </div>
      </div>
      <div className="flex h-full flex-col gap-3 rounded-b-lg bg-white px-8 py-6">
        {duration && (
          <div className="flex flex-col gap-1 border-b border-blue-300 pb-3 last:border-b-0 last:pb-0">
            <span className="text-sm text-slate-900">Varighet</span>
            <span className="text-base text-black">{duration}</span>
          </div>
        )}
        {credits && (
          <div className="flex flex-col gap-1 border-b border-blue-300 pb-3 last:border-b-0 last:pb-0">
            <span className="text-sm text-slate-900">Studiepoeng</span>
            <span className="text-base text-black">{credits}</span>
          </div>
        )}
        {startDate && (
          <div className="flex flex-col gap-1 border-b border-blue-300 pb-3 last:border-b-0 last:pb-0">
            <span className="text-sm text-slate-900">Studiestart</span>
            <span className="text-base text-black">{startDate}</span>
          </div>
        )}
        {educationForm && (
          <div className="flex flex-col gap-1 border-b border-blue-300 pb-3 last:border-b-0 last:pb-0">
            <span className="text-sm text-slate-900">Utdanningsform</span>
            <span className="text-base text-black">{educationForm}</span>
          </div>
        )}
      </div>
    </article>
  )
}
